import React, { useCallback, useRef } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { KeyboardAwareScrollView } from 'utils/packages/rnKeyboardAwareScrollview';
import { rem, AppView, Indicator } from 'design-system';
import AddressInput from 'design-system/address/AddressInput';
import Button from 'design-system/Button';
import StatusBar from 'design-system/StatusBar';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useUserAddress } from 'hooks';
import { useAppSelector } from 'store/hooks';
import AddressInputUS from 'design-system/address/AddressInputUS';
import { useMarginBottom } from 'hooks/useMarginBottom';
const AnimatedScroll = Animated.createAnimatedComponent(KeyboardAwareScrollView);
const strings = {
    editAddress: 'Edit Address',
    save: 'Save',
};
const EXTRA_KEYBOARD_PADDING = rem(50);
export const EditAddressScreen = withAnimatedNavigationHeader(({ scrollY, navigation: { goBack } }) => {
    const addressInputRef = useRef(null);
    const userCountry = useAppSelector((state) => state.user.user.guessedHomeCountry);
    const { primaryAddress, areUserAddressesFetching, fetchUserAddressesError, onUpdateUserAddress, isUserAddressUpdating, } = useUserAddress();
    const updateUserAddress = useCallback(async () => {
        const result = await addressInputRef.current?.validateInputs();
        if (!result)
            return;
        await onUpdateUserAddress(result);
        goBack();
    }, [goBack, onUpdateUserAddress]);
    const scrollHandler = useAnimatedScrollHandler(({ contentOffset }) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = contentOffset.y;
    });
    const paddingBottom = useMarginBottom('paddingBottom', undefined, styles.contentContainer);
    if (areUserAddressesFetching || fetchUserAddressesError) {
        return (<AppView type="secondary">
          <StatusBar barStyle="dark-content" animated/>
          <View style={styles.container}>
            <Indicator dark style={styles.indicator} includeHeaderHeight/>
          </View>
        </AppView>);
    }
    return (<AppView type="secondary">
        <StatusBar barStyle="dark-content" animated/>
        <View style={styles.container}>
          <AnimatedScroll viewIsInsideTabBar overScrollMode="never" scrollEventThrottle={16} onScroll={scrollHandler} style={styles.scrollView} keyboardShouldPersistTaps="handled" extraScrollHeight={EXTRA_KEYBOARD_PADDING} contentContainerStyle={paddingBottom} showsVerticalScrollIndicator={false}>
            {userCountry === 'US' ? (<AddressInputUS ref={addressInputRef} defaultAddress={primaryAddress} onSubmitEditing={updateUserAddress}/>) : (<AddressInput ref={addressInputRef} defaultAddress={primaryAddress} onSubmitEditing={updateUserAddress}/>)}
          </AnimatedScroll>
          <Button brand floating title={strings.save} onPress={updateUserAddress} loading={isUserAddressUpdating}/>
        </View>
      </AppView>);
}, {
    title: strings.editAddress,
});
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    button: {
        margin: rem(16),
    },
    indicator: {
        flex: 1,
    },
    contentContainer: {
        paddingTop: rem(16),
    },
    scrollView: {
        flex: 1,
    },
});
